module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-3x3-gap-aa508258.svg";